import { createSlice, EntityState } from '@reduxjs/toolkit';
import { vehicleAdapter } from '../entities/vehicle.entity';
import { Vehicle } from '../models/reservation.model';
import { RootState } from '../store';

type VehicleEntityState = {
  loadingVehicle: boolean;
  loadedVehicle: boolean;
};

const vehicleSlice = createSlice({
  name: 'vehicleV2',
  initialState: vehicleAdapter.getInitialState<VehicleEntityState>({
    loadingVehicle: false,
    loadedVehicle: false,
  }),
  reducers: {
    setVehicles: (state, action: { payload: Vehicle[] }) => {
      vehicleAdapter.setMany(state, action.payload);
    },
    setVehicle: (state, action: { payload: Vehicle }) => {
      vehicleAdapter.setOne(state, action.payload);
    },
    setLoadingVehicle: (state, action: { payload: boolean }) => {
      state.loadingVehicle = action.payload;
    },
    setLoadedVehicle: (state, action: { payload: boolean }) => {
      state.loadedVehicle = action.payload;
    },
    upsertVehicles: (state, action: { payload: Vehicle[] }) => {
      vehicleAdapter.upsertMany(state, action.payload);
    },
    upsertVehicle: (state, action: { payload: Vehicle }) => {
      vehicleAdapter.upsertOne(state, action.payload);
    },
  },
});

export const {
  setVehicles,
  setVehicle,
  setLoadingVehicle,
  setLoadedVehicle,
  upsertVehicles,
  upsertVehicle,
} = vehicleSlice.actions;

/*
 * Selectors
 * All necessary selectors for filtering and selecting vehicles
 */

const vehicleSelectors = vehicleAdapter.getSelectors<RootState>(
  (state) => state.vehicleV2,
);

const selectVehicleById = (state: RootState, vehicleID: number) =>
  vehicleSelectors.selectById(state, vehicleID);

export { vehicleSlice, vehicleSelectors, selectVehicleById };
